export default __webpack_public_path__ + "static/media/Icon_Class_ExSoldier.7ab80109.png";